import React from "react";

import SimpleReactValidator from "simple-react-validator";
import { format } from "date-fns";

import { withApollo } from "react-apollo";

import { updateCategory } from "../../services/graphql/queries/category-management";

import ReactModal from "../Common/ReactModal";
import InputComponent from "../Common/form-component/InputComponent";
import SelectComponent from "../Common/form-component/SelectComponent";
import TextAreComponent from "../Common/form-component/TextAreComponent";
import DisplayErrors from "../Common/DisplayErrors";
import { getCategoryStatus } from "../Common/ListOfInfoPortalStatus";

import { errorMessage } from "../../miscellaneous/error-messages";

import { SET_TIMEOUT_VALUE, dateFormatMonth } from "../../constants/app-constants";

class CategoryEdit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
        errors:[],
        categoryDetail:{
          name:"",
          description:"",
          displayOrder:100,
          status:"",
          viewByAllUsers:false,
        },
        
        reactModalVisible: false,
        requireCancel: false,
        modalMessage: ""
    }
    this.validator = new SimpleReactValidator({
        autoForceUpdate: this,
        element: message => <div style={{ color: "red" }}>{message}</div>
    });
    this.handleInput = this.handleInput.bind(this);
    this.updateCategory = this.updateCategory.bind(this);
    this.submitModal = this.submitModal.bind(this);

  }

  submitModal() {
    this.setState({ reactModalVisible: false, modalMessage: "" });
    this.props.onUpdateCategory();
    this.props.toggleEditMode(false);
  }

  handleInput(e) {
    let value = e.target.value;
    let name = e.target.name;
    this.setState(prevState => {
      return {
        categoryDetail: {
          ...prevState.categoryDetail,
          [name]: value
        }
      };
    });
  }

  updateCategory(e){
    e.preventDefault();
    if(this.validator.allValid()){
    this.state.categoryDetail.id = this.props.category.id;
    this.props.client
      .mutate({
        mutation: updateCategory,
        variables: this.state.categoryDetail,
        fetchPolicy: "no-cache"
      })
      .then(result => {
        this.setState({ reactModalVisible: true, modalMessage: "Updated Successfully" });
      })
      .catch(error => {
        console.log("~~~error: ", error);
        this.setState({ loading: false, errors: [errorMessage(error)] });
        this.timer = setTimeout(() => {
          this.setState({ errors: [] });
        }, SET_TIMEOUT_VALUE);
      });
    } else{
      this.validator.showMessages();
      // rerender to show messages for the first time
      // you can use the autoForceUpdate option to do this automatically`
      this.forceUpdate();
    }
  }

  updateData() {
    const {
      name,
      description,
      displayOrder,
      status,
      viewByAllUsers,
    } = this.props.category;
    let categoryDetail = {
      name: name,
      description: description,
      displayOrder: displayOrder,
      status: status,
      viewByAllUsers: viewByAllUsers,
    };

    this.setState({ categoryDetail: categoryDetail });
  }

  checkBoxChange(){
    let checkbox = document.getElementById('viewByAllUser');
    this.state.categoryDetail.viewByAllUsers = checkbox.checked;
    this.setState({ categoryDetail: this.state.categoryDetail});
  }

  componentDidMount(){
    this.updateData();
  }

  render() {
    const { errors, categoryDetail, reactModalVisible, requireCancel, modalMessage } = this.state;
    const { id, createdBy, createdOn, lastModifiedBy, lastModifiedOn, status, } = this.props.category;
    const statusOptions = getCategoryStatus(status);
    return (
      <>
        <ReactModal
          reactModalVisible={reactModalVisible}
          submitModal={this.submitModal}
          modalMessage={modalMessage}
          requireCancel={requireCancel}
        />
        <h1 className="heading m-b-25">Project Details - {id}</h1>
        <div
          className="row"
          style={{
              display: errors.length === 0 ? "none" : "block"
          }}
          >
          <div className="col-md-6">
              <div className="alert alert-success" role="alert">
              <div className="row">
                  <span className="danger-link">
                  <DisplayErrors errors={errors} />
                  </span>
              </div>
              </div>
          </div>
      </div>
      {/* Form Section start */}
      <form onSubmit={this.updateCategory}>
        <div className="row">
          <div className="col-md-9">
            
            <div className="box-card" style={{height: '350px'}}>
              <div className="row">
                <div className="col-md-6 col-lg-6">
                  <InputComponent
                    required
                    type="text"
                    title="Name"
                    name="name"
                    label="Name"
                    value={categoryDetail.name}
                    placeholder="Enter Name"
                    handleChange={this.handleInput}
                    validator={this.validator}
                    validation="required"
                  />
                </div>
                <div className="col-md-6 col-lg-6">
                  <div className="form-group">
                    <TextAreComponent 
                        required
                        title="Description"
                        name="description"
                        label="Description"
                        value={categoryDetail.description}
                        placeholder="Enter Description"
                        handleChange={this.handleInput}
                        validator={this.validator}
                        validation="required"
                    />
                  </div>
                </div>
                
                
              </div>
              
              <div className="row">
                <div className="col-md-6 col-lg-3">
                  <div className="form-group">
                    <label>Created By <span style={{color: 'red'}}>*</span></label>
                    {/* <input type="text" readOnly className="form-control-plaintext" value={createdByDetail && createdByDetail.loginId ? createdByDetail.loginId : ""} /> */}
                    <div className="form-control-plaintext word-break">{createdBy && createdBy.loginId ? createdBy.loginId : ""}</div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div className="form-group">
                    <label>Created On<span style={{color: 'red'}}>*</span></label>
                    {/* <input type="text" readOnly className="form-control-plaintext" value={createdOn?format(createdOn, dateFormatMonth):''} /> */}
                    <div className="form-control-plaintext word-break">{createdOn?format(createdOn, dateFormatMonth):''}</div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div className="form-group">
                    <label>Last Modified By<span style={{color: 'red'}}>*</span></label>
                    {/* <input type="text" readOnly className="form-control-plaintext" value={modifiedByDetail && modifiedByDetail.loginId ? modifiedByDetail.loginId : ""} /> */}
                    <div className="form-control-plaintext word-break">{lastModifiedBy && lastModifiedBy.loginId ? lastModifiedBy.loginId : ""}</div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div className="form-group">
                    <label>Last Modified On <span style={{color: 'red'}}>*</span></label>
                    {/* <input type="text" readOnly className="form-control-plaintext"  value={lastModifiedOn?format(lastModifiedOn, dateFormatMonth):''} /> */}
                    <div className="form-control-plaintext word-break">{lastModifiedOn?format(lastModifiedOn, dateFormatMonth):''}</div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <button type="submit" className="btn btn-danger">Submit</button>
                  <button type="button" className="btn btn-light m-l-45" onClick={() => this.updateData()}>Reset</button>
                </div>
              </div>
            </div>
          </div>
          
          <div className="col-md-3">
            <div className="box-card" style={{height: '350px'}}>
              <div className="row">
                <div className="col-md-12 col-lg-12">
                    <SelectComponent
                      required
                      label={"Status"}
                      title={"status"}
                      name={"status"}
                      options={statusOptions}
                      optionKey={"name"}
                      valueKey={"id"}
                      value={categoryDetail.status}
                      placeholder={"Select Statuus"}
                      handleChange={this.handleInput}
                      validator={this.validator}
                      validation="required"
                    />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-lg-12">
                  <InputComponent
                    required
                    type="text"
                    title="DisplayOrder"
                    name="displayOrder"
                    label="DisplayOrder"
                    value={categoryDetail.displayOrder}
                    placeholder="Enter Display Order"
                    handleChange={this.handleInput}
                    validator={this.validator}
                    validation="required"
                  />
                </div>
              </div>
              <div className="row">
                  <div className="col-md-12 col-lg-12">
                    <div className="form-group">
                      <label>View By All : </label>
                      <input type="checkbox" id="viewByAllUser" checked={categoryDetail.viewByAllUsers} style={{marginLeft: '3px', width: '15px', height: '15px'}}
                      onClick={()=>this.checkBoxChange()}
                      />
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
        </form>
        {/* Form Section End */}
      </>
    );
  }
}

export default withApollo(CategoryEdit);  